module.exports = __webpack_public_path__ + "media/images/room_monitor/dry_vacancy-8c84d9f930476e0da2df55ae75160c59.png";